import { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Button } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { A4 } from 'components/shared/print'
import './preview.scss'
import styled from 'styled-components'
import moment from 'moment'
import _ from 'lodash'
import template from 'components/../../public/sashidashihyo.jpg'
import { LiteSample, LiteSampleSearchForm } from 'entities/lite_sample'
import { useFetchLiteSamplesApi } from 'api/lite_sample'
const isHomeTest = !!process.env.REACT_APP_IS_HOME_TEST

type Props = {
    history: H.History
}

const Th = styled.th`
    border-right: solid 1px black;
    background-color: #e1e1e1;
    padding: 5px 10px;
    text-align: center;
    font-size: 14px;
    vertical-align: center;
`

const Td = styled.td`
    border-right: solid 1px black;
    padding: 5px;
`

const LitePostageSlipsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<LiteSampleSearchForm>()
    const [post, setPost] = useState<number>(0)
    const pricePerLetter = isHomeTest ? 180 : 270

    const searchForm = useForm<LiteSampleSearchForm>({
        ...params,
        perPage: 1000,
    })
    const liteSamplesApi = useFetchLiteSamplesApi(searchForm)

    useEffect(() => {
        liteSamplesApi.execute()
    }, [])

    useEffect(() => {
        if (liteSamplesApi.response.results.length === 0) return
        setPost(liteSamplesApi.response.results.length)
    }, [liteSamplesApi.response.results])

    useEffectSkipFirst(() => {
        globalState.setLoading(liteSamplesApi.loading)
    }, [liteSamplesApi.loading])

    const checklistChunk = (): LiteSample[][] => {
        if (liteSamplesApi.response.results) {
            return _.chunk(liteSamplesApi.response.results, 15)
        }
        return []
    }

    return (
        <div className="preview-request-form">
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="center">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            <A4 padding={0} landscape={false}>
                <div className="page-root" style={{ width: '100.5%', height: '100%', position: 'relative' }}>
                    <img src={template} style={{ objectFit: 'contain', width: '100%' }} />
                    {/*  通数  */}
                    {isHomeTest ? (
                        <div style={{ position: 'absolute', left: 402, top: 412, fontSize: 17, width: 69, textAlign: 'center' }}>{post.toLocaleString()}</div>
                    ) : (
                        <div style={{ position: 'absolute', left: 402, top: 447, fontSize: 17, width: 69, textAlign: 'center' }}>{post.toLocaleString()}</div>
                    )}
                    {/* 合計通数 */}
                    <div style={{ position: 'absolute', left: 402, top: 1036, fontSize: 17, width: 69, textAlign: 'center' }}>{post.toLocaleString()}</div>

                    {/*  通数×金額  */}
                    {isHomeTest ? (
                        <div style={{ position: 'absolute', left: 555, top: 412, fontSize: 17, width: 78, textAlign: 'center' }}>
                            {(post * pricePerLetter).toLocaleString()}
                        </div>
                    ) : (
                        <div style={{ position: 'absolute', left: 555, top: 447, fontSize: 17, width: 78, textAlign: 'center' }}>
                            {(post * pricePerLetter).toLocaleString()}
                        </div>
                    )}
                    {/* 合計金額 */}
                    <div style={{ position: 'absolute', left: 555, top: 1036, fontSize: 17, width: 78, textAlign: 'center' }}>
                        {(post * pricePerLetter).toLocaleString()}
                    </div>
                </div>
            </A4>

            {checklistChunk().map((samples, index) => {
                return (
                    <A4 padding={10} landscape={false} key={'checklist-' + index}>
                        <div className={'preview-request-list'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                            <div style={{ width: '100%', marginBottom: 30, marginTop: 30 }}>
                                <div style={{ width: '100%', textAlign: 'right', marginBottom: 30 }}>{moment().format('YYYY/MM/DD')}</div>
                                <div style={{ fontSize: 25, fontWeight: 'bold', width: '100%', textAlign: 'center' }}>郵便書類チェックリスト</div>
                            </div>

                            <table style={{ width: '100%', border: 'solid 1px black', borderRightWidth: 0, borderBottomWidth: 0, fontSize: 12 }}>
                                <thead>
                                    <tr style={{ borderBottom: 'solid 1px black' }}>
                                        <Th style={{ fontSize: 12, width: 30 }}>#</Th>
                                        <Th style={{ fontSize: 12, width: 100 }}>検体コード</Th>
                                        <Th style={{ fontSize: 12, width: 150 }}>{isHomeTest ? 'お届け先のお名前' : 'お届け先施設'}</Th>
                                        {!isHomeTest && <Th style={{ fontSize: 12, width: 120 }}>患者氏名</Th>}
                                        <Th style={{ fontSize: 12, width: 140 }}>結果表</Th>
                                        {!isHomeTest && (
                                            <Th style={{ fontSize: 12, width: 90 }}>
                                                <div>
                                                    結果表
                                                    <br />
                                                    (控え)
                                                </div>
                                            </Th>
                                        )}
                                        {!isHomeTest && <Th style={{ fontSize: 12, width: 90 }}>パンフレット</Th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {new Array(15).fill(0).map((_, sampleIndex) => {
                                        const sample: LiteSample | undefined = samples[sampleIndex]

                                        return (
                                            <tr key={sample?.id} style={{ borderBottom: 'solid 1px black' }}>
                                                <Td style={{ verticalAlign: 'inherit' }}>
                                                    <div style={{ minHeight: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <div>{sampleIndex + 1}</div>
                                                    </div>
                                                </Td>
                                                <Td>{sample?.code}</Td>
                                                <Td style={{ fontSize: 10, padding: '0 5px' }}>
                                                    {isHomeTest
                                                        ? sample
                                                            ? `${sample?.patient?.familyName || ''} ${sample?.patient?.givenName || ''}(${
                                                                  sample?.patient?.familyNameKana || ''
                                                              } ${sample?.patient?.givenNameKana || ''})`
                                                            : ''
                                                        : sample?.institution?.name}
                                                </Td>
                                                {!isHomeTest && (
                                                    <Td style={{ fontSize: 10, padding: '0 5px' }}>
                                                        {sample ? `${sample?.patient?.familyNameKana || ''} ${sample?.patient?.givenNameKana || ''}` : ''}
                                                    </Td>
                                                )}
                                                <Td>
                                                    <Flex justifyContent="center">
                                                        <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                    </Flex>
                                                </Td>
                                                {!isHomeTest && (
                                                    <Td>
                                                        <Flex justifyContent="center">
                                                            <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                        </Flex>
                                                    </Td>
                                                )}
                                                {!isHomeTest && (
                                                    <Td>
                                                        <Flex justifyContent="center">
                                                            <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                        </Flex>
                                                    </Td>
                                                )}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>

                            <Flex justifyContent="flex-end" style={{ marginTop: 30 }}>
                                <div>
                                    <table style={{ fontSize: 14, border: 'solid 1px black' }}>
                                        <thead style={{ backgroundColor: '#e1e1e1', borderBottom: 'solid 1px black', textAlign: 'center' }}>
                                            <tr>
                                                <th style={{ width: 100, borderRight: 'solid 1px black' }}>封入者</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ borderRight: 'solid 1px black' }}>
                                                    <div style={{ height: 60 }}></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Flex>
                        </div>
                    </A4>
                )
            })}
        </div>
    )
}

export default withRouter(LitePostageSlipsPage)
